<!-- @veltra/icons generated sha256:473aaa1149ac8e1c gen:8 source:src/svg/normal/add-child.svg -->
<script setup lang="ts">
defineOptions({ name: 'AddChild' })
</script>
<template>
  <svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 1024 1024">
    <path
      d="M870.4 68.267a68.267 68.267 0 0 1 68.267 68.266v238.934a68.267 68.267 0 0 1-68.267 68.266H247.467V742.4H409.6v-93.867a68.267 68.267 0 0 1 66.133-68.232l2.134-.034H870.4a68.267 68.267 0 0 1 68.267 68.266v238.934a68.267 68.267 0 0 1-68.267 68.266H477.867a68.267 68.267 0 0 1-68.267-68.266v-76.8H230.4a51.2 51.2 0 0 1-51.166-49.28l-.034-1.92V443.733h-42.667A68.267 68.267 0 0 1 68.301 377.6l-.034-2.133V136.533a68.267 68.267 0 0 1 68.266-68.266zm0 580.266H477.867v238.934H870.4zm0-512H136.533v238.934H870.4z"
    />
  </svg>
</template>
